import { useEffect } from "react";
import PropTypes from "prop-types";
import SmartDPHotelDescription from "app/pages/SmartDP/Quote/HotelDescription/SmartDPHotelDescription";
import { bindActionCreators } from "redux";
import { fetchSDPAccommodationDescription } from "app/pages/SmartDP/smartDPActionCreators";
import { connect } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { closeSlideshow, openSlideshow } from "app/pages/.shared/Slideshow/SlideShowActionCreators";
import { parseQueries } from "app/utils/routerUtils";
import { checkForSpecialOffer } from "app/pages/Booking/Payment/paymentSelector";
import get from "lodash/get";
import usePrintMode from "app/reducers/usePrintMode";
import { startPrint } from "app/reducers/printActionCreators";
import { fetchStopoverAccommodationDescription } from "app/pages/Stopover/stopoverActionCreators";
import { fetchHotelOnlyAccommodationDescription } from "app/pages/HotelOnly/Booking/pages/Quote/BookingQuoteActionCreator";

const SmartDPHotelDescriptionContainer = props => {
	const {
		quotationCode,
		closeSlideshow,
		isStopover,
		isHotelOnly,
		fetchSDPAccommodationDescription,
		fetchStopoverAccommodationDescription,
		fetchHotelOnlyAccommodationDescription,
		startPrint,
	} = props;
	const params = useParams();
	const location = useLocation();

	const isPrintMode = usePrintMode();

	// Extract only the params needed for API calls
	const query = parseQueries(location.search);
	const accommodationIdFromQuery = query.accommodationId;
	const stopoverDuration = query.stopoverDuration;
	const codeFromState = location.state?.code;

	// Compute final values sent to API (not individual sources)
	const { accommodationId: accommodationIdFromParam, code: paramCode } = params;
	const accommodationIdForPayload = accommodationIdFromParam || accommodationIdFromQuery;
	const codeForPayload = codeFromState || paramCode || quotationCode;

	useEffect(() => {
		if (isPrintMode) {
			startPrint();
		}
	}, [isPrintMode]);

	useEffect(() => {
		if (!isHotelOnly && codeForPayload && accommodationIdForPayload) {
			if (isStopover) {
				fetchStopoverAccommodationDescription({
					bookingFlowId: codeForPayload,
					accommodationId: accommodationIdForPayload,
					stopoverDuration,
				});
			} else {
				fetchSDPAccommodationDescription({
					code: codeForPayload,
					accommodationId: accommodationIdForPayload,
				});
			}
		} else if (isHotelOnly && codeForPayload && accommodationIdForPayload) {
			fetchHotelOnlyAccommodationDescription({
				id: parseInt(accommodationIdForPayload, 10),
				bookingFlowId: get(location, "state.code") || codeForPayload,
			});
		}
		return () => {
			closeSlideshow();
		};
	}, [accommodationIdForPayload, codeForPayload, stopoverDuration, isStopover, isHotelOnly]);

	return <SmartDPHotelDescription {...props} />;
};

SmartDPHotelDescriptionContainer.propTypes = {
	quotationCode: PropTypes.string,
	fetchSDPAccommodationDescription: PropTypes.func,
	fetchStopoverAccommodationDescription: PropTypes.func,
	fetchHotelOnlyAccommodationDescription: PropTypes.func,
	isStopover: PropTypes.bool,
	isHotelOnly: PropTypes.bool,
	closeSlideshow: PropTypes.func,
	startPrint: PropTypes.func,
};

const mapStateToProps = state => {
	return {
		hotel: state.ficheProduit,
		quotationCode: state.smartDP.code,
		slideshow: state.slideshow,
		hasSdpSpecialOffer: checkForSpecialOffer(state), // true si le back renvoi au moins un vol remboursable
		specialOfferInfos: state.ficheProduit.specialOffer,
		googleAPIKey: state.envVars.GOOGLE_API_KEY,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			fetchSDPAccommodationDescription,
			fetchStopoverAccommodationDescription,
			fetchHotelOnlyAccommodationDescription,
			closeSlideshow,
			openSlideshow,
			startPrint,
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SmartDPHotelDescriptionContainer);
